export default __webpack_public_path__ + "static/media/Heebo-Bold.a7c70579.ttf";